import React, { useEffect, useState } from 'react';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import * as actions from '../../../../../services/actions';
import AffichageGraphe from '../../../../Graphe/AffichageGraphe/AffichageGraphe';
import FormulaireGraphe from './FormulaireGraphe/FormulaireGraphe';
import styles from './ProfilGraphe.module.scss';

const ProfilGraphe = ({ infoGraphe }) => {
  const [configurationGraphe, setConfigurationGraphe] = useState({
    graph_id: null,
  });
  const [afficherModifier, setAfficherModifier] = useState(false);

  const dispatch = useDispatch();
  const listeConfigurationsGraphes = useSelector(
    (state) => state.graphe.liste_configurations_graphes
  );

  useEffect(() => {
    if (
      infoGraphe.graph_id &&
      (listeConfigurationsGraphes[infoGraphe.graph_id] === undefined ||
        configurationGraphe.graph_id !== infoGraphe.graph_id)
    ) {
      dispatch(actions.reqRecupererGraphe(infoGraphe.graph_id));
      setConfigurationGraphe({
        ...listeConfigurationsGraphes[parseInt(infoGraphe.graph_id)],
      });
      setAfficherModifier(false);
    }
  }, [infoGraphe.graph_id]);

  const formulaireModifier =
    listeConfigurationsGraphes[infoGraphe.graph_id] !== undefined ? (
      <FormulaireGraphe
        annuler={() => setAfficherModifier(false)}
        preconfigurerGraphe={listeConfigurationsGraphes[infoGraphe.graph_id]}
      />
    ) : null;

  const profil = (
    <>
      <div className={[s.row, styles.ConteneurInfo].join(' ')}>
        {listeConfigurationsGraphes[parseInt(infoGraphe.graph_id)] !==
          undefined &&
        listeConfigurationsGraphes[parseInt(infoGraphe.graph_id)].graph_id ===
          parseInt(infoGraphe.graph_id) ? (
          <div className={[s.col_12, s.text_left].join(' ')}>
            <FormulaireGraphe
              affichageProfil={true}
              annuler={() => setAfficherModifier(false)}
              preconfigurerGraphe={
                listeConfigurationsGraphes[infoGraphe.graph_id]
              }
            />
          </div>
        ) : null}

        <div className={[s.row, styles.bts].join(' ')}>
          <div className={styles.sas}>
            <AffichageGraphe graph_id={infoGraphe.graph_id} />
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div className={styles.ConteneurInfo}>
      <div className={[s.card_header, styles.hedes].join(' ')}>
        <BsFillInfoCircleFill size={14} />
        {checkMot('graphe_id')} : {infoGraphe.graph_id}
      </div>
      <div className={s.container}>
        {afficherModifier ? formulaireModifier : profil}
      </div>
    </div>
  );
};

export default ProfilGraphe;
